const locale = {
  'Download.unnamedDownloadFile': 'Unnamed download file',
  'Download.unNamedDownloadFile': 'Unnamed download file',
  'Download.notFoundFile': 'The downloaded file information was not obtained',
  'Download.downloadSuccess': 'Downloads successful',
  'FileUpload.fileUpload': 'Upload file',
  'FileUpload.uploadTips': 'Supports the extension {accept}, with a single file size not exceeding {fileSize}M and uploading up to {maxLength} attachments',
  'FileUpload.maxLengthError': 'Upload files cannot exceed the maximum allowed number {maxLength}',
  'FileUpload.fileSizeError': 'The file {filename} cannot exceed {fileSize}MB!',
  'FileUpload.acceptError': 'File {filename} is not allowed. Supported types: {accept}',
  'FileUpload.uploadError': 'File {filename} upload error {error}',
  'FileUpload.uploadAnomaly': 'File {filename} upload exception {error}',
  'FileUpload.separator': ',',
  'FilePreview.fileLoadedError': 'File loading failed',
  'FilePreview.fileNotFoundError': 'Unspecified file',
  'FilePreview.pageNotFoundError': 'Unspecified page',
  'FilePreview.unSupportFileType': 'Unsupported file types',
  'FilePreview.unSupportFileTypeDescription': 'The system does not support file type preview, please download it locally to preview it',
  'FilePreview.filePreview': 'File preview',
  'FilePreview.zipArchive': 'Archive',
  'FilePreview.fileName': 'File Name',
  'FilePreview.fileSize': 'File Size',
  'FilePreview.compressedSize': 'Compressed Size',
  'FilePreview.remotePreview': 'Native preview',
  'FilePreview.localPreview': 'Local preview',
  'FileList.uploading': 'Uploading',
  'FileButton.pleaseSetApi': 'Please set the preset.apis.file.getUrl parameter in the Global component',
  'FileSystem.viewGrid': 'Grid',
  'FileSystem.viewList': 'List',
  'FileSystem.viewColumns': 'Columns',
  'FileSystem.viewGallery': 'Gallery',
  'FileSystem.columnName': 'Name',
  'FileSystem.columnSize': 'Size',
  'FileSystem.folder': 'Folder',
  'FileSystem.emptyFolder': 'This folder is empty',
  'FileSystem.currentFolder': 'Current Folder',
  'FileSystem.notFound': '"{keyword}" not found',
  'FileSystem.search': 'Search',
  'FileSystem.resultCount': 'results',
  'FileSystem.itemCount': 'items',
  'FileSystem.selected': 'Selected "{name}"'
};

export default locale;
